import list from './list'
import show from './show'
import edit from './edit'

export default {
  list,
  show,
  edit
}
